import { Box } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import React from 'react';
import { Asset } from 'types';
import SmallCard from './SmallCard';

const LatestAssets = ({
  assets,
  route,
}: {
  assets: Asset[];
  route: string;
}) => {
  const { isMobile } = useResponsive();
  return (
    <Box
      as="article"
      justify="center"
      height="medium"
      align="center"
      direction={isMobile ? 'column' : 'row'}
      animation="fadeIn"
      fill="horizontal"
      margin={{ top: 'medium', bottom: 'large' }}
    >
      {assets.map((asset, i) => (
        <Box key={i} fill={true}>
          <SmallCard {...asset} route={route} />
        </Box>
      ))}
    </Box>
  );
};

export default LatestAssets;
